import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum QuestionnaireTemplateStatus {
  Draft = 0,
  Published = 1,
  Updated = 2
}

export const QuestionnaireTemplateStatusList: EnumOption[] = createEnumOptions(QuestionnaireTemplateStatus);
